webpackJsonp([27],{

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1016), __esModule: true };

/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1017), __esModule: true };

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(350);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1013);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1012);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(225);
__webpack_require__(150);
module.exports = __webpack_require__(1018);


/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(225);
__webpack_require__(150);
module.exports = __webpack_require__(1019);


/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(53);
var get = __webpack_require__(235);
module.exports = __webpack_require__(16).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(234);
var ITERATOR = __webpack_require__(17)('iterator');
var Iterators = __webpack_require__(86);
module.exports = __webpack_require__(16).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 1035:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(1015);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = __webpack_require__(1014);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _assignIn2 = __webpack_require__(155);

var _assignIn3 = _interopRequireDefault(_assignIn2);

var _reduce3 = __webpack_require__(976);

var _reduce4 = _interopRequireDefault(_reduce3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'amp-field-body',
  props: {
    bodyOptions: Object
  },
  components: {
    AmpText: function AmpText() {
      return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1691));
    },
    AmpImage: function AmpImage() {
      return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1689));
    },
    AmpIframe: function AmpIframe() {
      return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1688));
    },
    AmpAlsoRead: function AmpAlsoRead() {
      return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1682));
    },
    AmpBlockquote: function AmpBlockquote() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1685));
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['activeNID']), {
    node: function node() {
      return this.$store.getters.node(this.activeNID);
    },
    contentList: function contentList() {
      var counter = {};
      (0, _forEach2.default)((0, _get2.default)(this, 'node.contentList', []), function (value) {
        counter = (0, _assignIn3.default)(counter, (0, _defineProperty3.default)({}, '' + value.type, (0, _get2.default)(counter, '[' + value.type + ']', 0) + 1));
        value.itemTypeIndex = counter['' + value.type];
      });
      return (0, _get2.default)(this, 'node.contentList', []);
    },
    relatedArticles: function relatedArticles() {
      return (0, _get2.default)(this, 'node.related_articles', []);
    },
    getBodyOptions: function getBodyOptions() {
      return (0, _assignIn3.default)({
        countDown: false,
        photoOverlay: false,
        inlineNewsletter: true,
        hideParagraphArrow: false,
        alsoRead: {
          enable: true,
          alsoReadLayout: [4, 3, 4, 4, 4],
          insertPosition: [6, 9, 12, 15, 18]
        }
      }, this.bodyOptions);
    },
    alsoReadArticlesIndexesAvailable: function alsoReadArticlesIndexesAvailable() {
      var _this = this;

      var bodyOptionPositionsArray = (0, _get2.default)(this, 'getBodyOptions.alsoRead.insertPosition', []);

      var _reduce = (0, _reduce4.default)(bodyOptionPositionsArray, function (result, position) {
        result[position - 1 <= _this.contentList.length ? 0 : 1].push(position - 1);
        return result;
      }, [[], []]),
          _reduce2 = (0, _slicedToArray3.default)(_reduce, 2),
          pass = _reduce2[0],
          fail = _reduce2[1];

      var indexesAvailableForAlsoRead = { pass: pass, fail: fail };
      return indexesAvailableForAlsoRead;
    },
    alsoReadArticles: function alsoReadArticles() {
      var _this2 = this;

      var isEnabled = (0, _get2.default)(this, 'getBodyOptions.alsoRead.enable', false);
      var alsoReadArticles = [];

      if (isEnabled) {
        var bodyOptionPositionsArray = (0, _get2.default)(this, 'getBodyOptions.alsoRead.insertPosition', []);
        var bodyOptionsLayoutsArray = (0, _get2.default)(this, 'getBodyOptions.alsoRead.alsoReadLayout', []);
        var indexesAvailablePass = (0, _get2.default)(this, 'alsoReadArticlesIndexesAvailable[pass]', []);

        (0, _forEach2.default)(this.relatedArticles, function (article, articleIndex) {
          var getLayoutType = 4;
          var getInsertAtIndex = _this2.contentList.length;
          var getIsIndexAvailable = false;

          (0, _forEach2.default)(bodyOptionsLayoutsArray, function (type, typeIndex) {
            if (articleIndex === typeIndex) {
              getLayoutType = type;
              return false;
            }
            return true;
          });

          (0, _forEach2.default)(bodyOptionPositionsArray, function (position, positionIndex) {
            if (articleIndex === positionIndex) {
              getInsertAtIndex = position - 1;
              return false;
            }
            return true;
          });

          (0, _forEach2.default)(indexesAvailablePass, function (Available) {
            if (getInsertAtIndex === Available) {
              getIsIndexAvailable = true;
              return false;
            }
            return true;
          });

          while ((0, _get2.default)(_this2, 'contentList[' + getInsertAtIndex + '].content.html') && _this2.contentList[getInsertAtIndex].content.html.match(/<h[1-5]>(.*)?<\/h[1-5]>/)) {
            getInsertAtIndex -= 1;
          }var alsoReadDetails = {
            node: article,
            layoutType: getLayoutType,
            insertAtIndex: getInsertAtIndex,
            isIndexAvailable: getIsIndexAvailable,
            isLast: articleIndex === _this2.relatedArticles.length - 1
          };

          alsoReadArticles.push(alsoReadDetails);
        });
      }
      return alsoReadArticles;
    }
  })
};

/***/ }),

/***/ 1547:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".fieldBody[data-v-f3450fae]{position:relative;margin-top:1.125rem}.fieldBody[data-v-f3450fae]:before{background-image:url(\"/static/svg/raw/icon_arrow_right1.svg\");background-size:contain;content:\"\";display:block;height:1.5625rem;width:.9375rem;position:absolute;left:0;top:0}", "", {"version":3,"sources":["/app/components/article/amp/AmpFieldBody.vue"],"names":[],"mappings":"AAgCA,4BACE,kBAAmB,AACnB,mBAAqB,CACtB,AACD,mCACI,8DAA+D,AAC/D,wBAAyB,AACzB,WAAY,AACZ,cAAe,AACf,iBAAkB,AAClB,eAAiB,AACjB,kBAAmB,AACnB,OAAQ,AACR,KAAO,CACV","file":"AmpFieldBody.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.fieldBody[data-v-f3450fae] {\n  position: relative;\n  margin-top: 1.125rem;\n}\n.fieldBody[data-v-f3450fae]::before {\n    background-image: url(\"/static/svg/raw/icon_arrow_right1.svg\");\n    background-size: contain;\n    content: \"\";\n    display: block;\n    height: 1.5625rem;\n    width: 0.9375rem;\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1636:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1547);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("2e1ae398", content, true, {});

/***/ }),

/***/ 1687:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1636)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1343),
  /* template */
  __webpack_require__(1794),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f3450fae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1794:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fieldBody"
  }, _vm._l((_vm.contentList), function(item, index) {
    return _c('div', {
      key: index
    }, [(item.type === 'text') ? _c('amp-text', {
      attrs: {
        "item": item
      }
    }) : (item.type === 'image') ? _c('amp-image', {
      attrs: {
        "item": item
      }
    }) : (item.type === 'iframe') ? _c('amp-iframe', {
      attrs: {
        "item": item
      }
    }) : (item.type === 'blockquote') ? _c('amp-blockquote', {
      attrs: {
        "item": item
      }
    }) : _vm._e(), _vm._l((_vm.alsoReadArticles), function(article, articleIndex) {
      return (_vm.getBodyOptions.alsoRead.enable) ? [(article.insertAtIndex === index && article.isIndexAvailable) ? _c('amp-also-read', {
        key: articleIndex,
        attrs: {
          "data-index": index,
          "article": article
        }
      }) : _vm._e()] : _vm._e()
    })], 2)
  }))
},staticRenderFns: []}

/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(352),
    baseEach = __webpack_require__(108),
    baseIteratee = __webpack_require__(74),
    baseReduce = __webpack_require__(1035),
    isArray = __webpack_require__(10);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ })

});


// WEBPACK FOOTER //
// 27.b7b23cfcd7f54bd67fc8.js